import React, {useState} from "react";
import {
	Backdrop,
	Button, ButtonGroup, Checkbox,
	CircularProgress, Divider,
	FormControlLabel,
	Stack,
	Switch,
	TextField, Tooltip
} from "@mui/material";
import {translateFunction} from "../../../../localization/TranslationService";
import {DocumentMeta} from "../../models/DocumentMeta";
import {graphQLServices} from "../../../../services/GraphQLServices";
import {toast} from "react-toastify";
import {MetaValueType} from "../../models/MetaValueType";
import {MULTI_EDIT} from "../graphql/mutations/gqlMultiEdit";


const translate = translateFunction("SureBaseDocuments");
interface IMultiEditCardProps{
	documentIds: number[];
}


export const MultiEditCard: React.FC<IMultiEditCardProps> = (props) => {

	const [submitLoading, setSubmitLoading] = useState<boolean>(false);
	const [comment, setComment] = useState<string>("");
	const [editComment, setEditComment] = useState<boolean>(false);

	const [editSpam, setEditSpam] = useState<boolean>(false);
	const [spam, setSpam] = useState<boolean>(false);

	const [approve, setApprove] = useState<boolean>(false);
	const process = () => {
		let metaData: DocumentMeta[] = [];

		if (editSpam) {
			metaData = [...metaData, {documentId: 0, key: "target", value : spam?"SPAM":"", valueType: MetaValueType.Boolean, timeStamp:new Date().toISOString(), changed: true, selected : true}];
		}

		setSubmitLoading(true);
		graphQLServices.documentsClient.mutate({
			mutation: MULTI_EDIT,
			variables: {
				input: {
					documentIds: props.documentIds,
					metaData: metaData,
					approve: approve,
					comment: editComment?comment:null
				}
			},
		})
			.then(() => {
				toast.success(translate(`Saved.`));
			})
			.catch((reason) => {
				toast.error(`Update failed.`);
				//setErrorMessage(reason.networkError.result.errors[0].extensions.message);
			} )
			.finally(() => {
				setSubmitLoading(false);
			});

	};



	return <>
		<Backdrop open={submitLoading}><CircularProgress/></Backdrop>

		{ props.documentIds && (
			<Stack spacing={1}>
				<Divider/>
				<FormControlLabel label={translate("Edit comment")} control={<Checkbox checked={editComment}  onChange={(event) => setEditComment(event.target.checked)} inputProps={{ "aria-label": "controlled" }} />} />
				{editComment && <TextField
					key={"comment"}
					label={translate("Comment")}
					value={comment}
					multiline
					onChange={(event) => setComment(event.target.value)}
					InputProps={{
						readOnly: false
					}}

					InputLabelProps={{
						shrink: true
					}}
				/>
				}
				<Divider/>
				<FormControlLabel label={translate("Edit Spam")} control={<Checkbox checked={editSpam}  onChange={(event) => setEditSpam(event.target.checked)} inputProps={{ "aria-label": "controlled" }} />} />
				{editSpam &&
						<FormControlLabel label={translate("Spam")} control={<Switch title={"Spam"}  checked={spam}   onChange={(event) => setSpam(event.target.checked)}/>} />
				}

				<Divider/>
				<FormControlLabel label={translate("Approve")} control={<Switch title={"Approve"}  checked={approve}   onChange={(event) => setApprove(event.target.checked)}/>} />
				<ButtonGroup variant="contained" aria-label="outlined primary button group">
					<Tooltip title={translate("Process")}><Button variant={"outlined"} onClick={process} >{translate("Process")}</Button></Tooltip>
				</ButtonGroup>
			</Stack>
		)
		}

	</>;
};
